import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function nameValidator(allowNumbers: boolean = false, allowSpaces: boolean = false): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value?.trim();

    if (!value) return null;
    if (!allowSpaces && /\s/.test(value)) {
      return { invalidName: 'Spaces are not allowed.' };
    }
    if (allowSpaces && /\s{2,}/.test(value)) {
      return { invalidName: 'Only one space is allowed between words.' };
    }
    if (!allowNumbers && /\d/.test(value)) {
      return { invalidName: 'Numbers are not allowed.' };
    }
    const allowedPattern = allowNumbers ? /^[a-zA-Z0-9_.\-\s]*$/ : /^[a-zA-Z_.\-\s]*$/;
    if (!allowedPattern.test(value)) {
      return {
        invalidName: 'Special characters are not allowed. Only allowed for underscores (_), dots (.), and hyphens (-).'
      };
    }

    return null;
  };
}
